export enum SpinnerVariant {
    White = 'White',
    Grey = 'Grey'
  }
  